export default class MissingEventError extends Error {
  constructor(message = '', ...args) {
    super(message, ...args)
    this.name = 'MissingEventError'
    this.message = message
  }
}
